export default "__VITE_ASSET__O5gIB$hi__"